import { Component, EventEmitter, Output, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LanguageService } from '../../../services/language.service';
import { Subscription, combineLatest } from 'rxjs';

@Component({
  selector: 'app-user-not-found-modal',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './user-not-found-modal.html',
  styleUrl: './user-not-found-modal.scss'
})
export class UserNotFoundModalComponent implements OnInit, OnDestroy {
  @Output() closeModal = new EventEmitter<void>();
  currentLanguage = 'en';
  private subscriptions: Subscription[] = [];

  constructor(
    private languageService: LanguageService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    // Subscribe to both language and translations changes
    // This ensures UI updates when translations load after page refresh
    this.subscriptions.push(
      combineLatest([
        this.languageService.currentLanguage$,
        this.languageService.translations$
      ]).subscribe(([language]) => {
        this.currentLanguage = language;
        this.cdr.markForCheck();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  translate(key: string): string {
    return this.languageService.translate(key);
  }

  // Alias for easier use in template
  t(key: string): string {
    return this.translate(key);
  }

  onCloseModal(): void {
    this.closeModal.emit();
  }

  onRegisterClick(): void {
    this.closeModal.emit();
    // Navigation will be handled by the router link in the template
  }
}
